import React from 'react'
import PropTypes from 'prop-types'
import { Grid, Row, Col, Form, FormInput } from 'shared/components'

import * as style from './styles'

import { getOptionLabel, getOptionValue } from './helpers'

const AthletesFiltersComponent = ({ form, loadSportTypes }) => (
  <Form form={form}>
    <Grid>
      <Row css={style.filtersWrapper}>
        <Col xs={12} sm={4}>
          <FormInput
            name="search"
            icon="search"
            placeholder="Search by name..."
            css={style.phoneSpace}
            grayBg
          />
        </Col>
        <Col xs={12} sm={4}>
          <FormInput
            fluid
            cacheOptions
            defaultOptions
            isSearchable={false}
            getOptionLabel={getOptionLabel}
            getOptionValue={getOptionValue}
            type="async-select"
            name="sportTypes"
            placeholder="Sport"
            loadOptions={loadSportTypes}
            oldInput
          />
        </Col>
      </Row>
    </Grid>
  </Form>
)

AthletesFiltersComponent.propTypes = {
  form: PropTypes.shape().isRequired,
  loadSportTypes: PropTypes.func.isRequired,
}

export default AthletesFiltersComponent
